import { useNavigate, useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import supabase from '../supabase';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { MAINTENANCE } from '../config';

const styles = `
    @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@300;400&display=swap');

  .region-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    padding: 1.8rem;
    max-width: 1100px;
    margin: 0 auto;
  }

  .album-card {
    position: relative;
    border-radius: 4px;
    overflow: hidden;
    cursor: pointer;
    aspect-ratio: 3 / 2;
    background: #ccc9c0;
    transition: transform 0.35s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
  .album-card:hover { transform: scale(1.015); }
  .album-card:hover .card-arrow { opacity: 1; transform: translate(0, 0); }
  .album-card:hover img { filter: brightness(0.48) saturate(0.75); }

  .album-card img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    filter: brightness(0.55) saturate(0.7);
    transition: filter 0.4s ease;
  }

  .card-date {
    position: absolute;
    top: 10px;
    right: 10px;
    font-size: 8px;
    letter-spacing: 0.06em;
    color: rgba(255,255,255,0.45);
    font-weight: 300;
  }

  .card-arrow {
    position: absolute;
    top: 10px;
    left: 12px;
    font-size: 13px;
    color: rgba(255,255,255,0.6);
    opacity: 0;
    transform: translate(-3px, 3px);
    transition: all 0.25s ease;
  }

  .card-info {
    position: absolute;
    bottom: 0; left: 0; right: 0;
    padding: 3rem 1rem 0.9rem;
    background: linear-gradient(transparent, rgba(10,9,7,0.72));
  }

  .card-title {
    font-family: 'Playfair Display', serif;
    font-size: 13px;
    font-style: italic;
    font-weight: 400;
    color: rgba(255,255,255,0.92);
    line-height: 1.35;
    margin: 0 0 4px 0;
  }

  .card-location {
    font-size: 8px;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: rgba(255,255,255,0.38);
    font-weight: 300;
    margin: 0;
  }

  @media (max-width: 600px) {
    .region-grid { grid-template-columns: 1fr; padding: 1rem; }
  }
`;

function Region() {
    const navigate = useNavigate();
    const { regionName } = useParams();
    const [albums, setAlbums] = useState([]);

    useEffect(() => {
        const fetchAlbums = async () => {
            const { data, error } = await supabase
                .from('albums')
                .select('*')
                .eq('region', regionName)
                .eq('archived', false);
            if (error) console.log(error);
            else setAlbums(data);
        };
        fetchAlbums();
    }, [regionName]);
    if (MAINTENANCE) return (
        <div style={{ position: 'relative', minHeight: '100vh', overflow: 'hidden', display: 'flex', alignItems: 'center', justifyContent: 'center', fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif' }}>
            <video autoPlay loop muted playsInline style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', zIndex: -1 }}>
                <source src="/video/background.mp4" type="video/mp4" />
            </video>
            <div style={{ position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.4)', zIndex: -1 }} />
            <div style={{ textAlign: 'center' }}>
                <p style={{ fontSize: '11px', letterSpacing: '0.15em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.4)', marginBottom: '12px' }}>winston.ie</p>
                <p style={{ fontSize: '13px', color: 'rgba(255,255,255,0.7)', fontWeight: '300', fontStyle: 'italic', letterSpacing: '0.02em' }}>Quietly reorganizing. Back soon.</p>
            </div>
        </div>
    );
    
    return (
        <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh', fontFamily: 'Helvetica Neue, Helvetica, Arial, sans-serif' }}>
            <style>{styles}</style>
            <Navbar variant="light" />

            <div style={{ flex: 1 }}>
                {/* Header — inchangé */}
                <div style={{ textAlign: 'center', padding: '48px 28px 16px' }}>
                    <h1 style={{ fontSize: '44px', fontWeight: '400', fontFamily: "'Playfair Display', serif", fontStyle: 'normal', letterSpacing: '0.02em', marginBottom: '4px' }}>
                        {regionName.charAt(0).toUpperCase() + regionName.slice(1).toLowerCase()}
                    </h1>
                    <p style={{ fontSize: '12px', color: '#999' }}>{albums.length} album{albums.length !== 1 ? 's' : ''}</p>
                </div>

                {/* Album Grid */}
                {albums.length === 0 ? (
                    <p style={{ color: '#888', fontStyle: 'italic', textAlign: 'center', padding: '2rem' }}>Coming Soon.</p>
                ) : (
                    <div className="region-grid">
                        {albums.map((album) => (
                            <div
                                key={album.title}
                                className="album-card"
                                onClick={() => navigate(`/region/${regionName}/${album.folder}`)}
                            >
                                {album.cover_url ? (
                                    <img src={album.cover_url} alt={album.title} />
                                ) : (
                                    <div style={{ width: '100%', height: '100%', background: '#ddd9d0' }} />
                                )}
                                <div className="card-date">{album.date}</div>
                                <div className="card-arrow">↗</div>
                                <div className="card-info">
                                    <p className="card-title">{album.title}</p>
                                    <p className="card-location">{album.location || album.region}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            <Footer />
        </div >
    );
}

export default Region;